import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Picker from "emoji-picker-react";
import ReactImageVideoLightbox from 'react-image-video-lightbox'
import firebase from "../../../config/firebase";
import { setProfileTabIndex } from "../../profile/modules/profile";
import { fetchConnectionTabs } from '../../NetworkConnection/modules/networkConnection';
import constant from '../../../helpers/constant';
import { uploadMedia } from '../module/messageModule';
import Modal from "react-modal";
import language from '../../../helpers/language';
import _ from 'lodash';

export default function MessageView() {
    const [lang] = useState(language.getLang());
    const messagesEndRef = useRef(null);
    const deletePopUpRef = useRef();
    const dispatch = useDispatch()
    const [userId, setUserId] = useState(null);
    const [userImage, setUserImage] = useState();
    const [userName, setUserName] = useState();
    const [chatId, setChatId] = useState(null);
    const [sendText, setSendText] = useState('')
    const [sendTextWithImg, setSendTextWithImg] = useState('')
    const [messages, setMessages] = useState([]);
    const [mediaType, setMediaType] = useState('');
    const [mediaImage, setMediaImage] = useState('');
    const [isOpenImage, setIsOpenImage] = useState(false);
    const [msgDelete, setMsgDelete] = useState(false);
    const [selectedFile, setSelectedFile] = useState(false);
    const [isChatStart, setisChatStart] = useState(false);
    const [recentMessage, setRecentMessage] = useState([]);
    const [userList, setUserList] = useState([]);
    const [searchUserList, setSearchUserList] = useState([]);
    const [connectionId, setConnectionId] = useState(null);
    const [firebaseNodeId, setFirebaseNodeId] = useState('')
    const [selectedRecentMessage, setSelectedRecentMessage] = useState();
    const [imageData, setImageData] = useState('');
    const [mobileViewList, setMobileViewList] = useState(true);

    const { profileData } = useSelector((state) => state.memberProfileData);
    const { connectionTabs } = useSelector((state) => state.networkConnectionState);
    const [tabIndex, setTabIndex] = useState(0);
    const [isEmoji, setIsEmoji] = useState(false);

    useEffect(async () => {
        const getUserId = await profileData?.data?.user_data?.user_id;
        await getUserId && fetchRecentMessage(getUserId)
        await dispatch(fetchConnectionTabs(constant.tabs.connection))
        await setUserId(getUserId)
    }, [profileData]);

    useEffect(async () => {
        const getBaseUrl = await profileData?.data?.user_data?.avatar_id?.base_url
        const getAttachment = await profileData?.data?.user_data?.avatar_id?.attachment_url
        const getUserImage = `${getBaseUrl}${getAttachment}`
        const getUserName = await profileData?.data?.user_data?.first_name !== null && profileData?.data?.user_data?.last_name !== null &&
            `${profileData?.data?.user_data?.first_name} ${profileData?.data?.user_data?.last_name}`
            || profileData?.data?.user_data?.company_name || profileData?.data?.user_data?.restaurant_name
        setUserImage(getUserImage)
        setUserName(getUserName)
    }, [profileData])

    useEffect(async () => {
        await fetchUserList()
    }, [recentMessage]);

    useEffect(async () => {
        await dispatch(setProfileTabIndex(0));
    }, [])

    // for scroll down start
    useEffect(async () => {
        await scrollToBottom();
    }, [messages]);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }
    //end scroll down

    useEffect(async () => {
        userList.length > 0 && await fetchMessage(userList[tabIndex])
    }, [tabIndex, userId])

    // contact list
    const fetchUserList = async () => {
        let connectionArr = []

        await connectionTabs?.data?.data.map(async (data) => {
            let item = data?.user;
            //console.log(data?.updated_at, 'data?.updated_at...')
            const model = {
                id: `user_${item.user_id}`,
                lastmessage: "",
                mediaType: "",
                otherId: item.user_id,
                otherImage: `${item?.avatar_id?.base_url}${item?.avatar_id?.attachment_url}`,
                otherName: `${(item?.first_name !== null && item?.last_name !== null && `${item?.first_name} ${item?.last_name}`) || (item?.company_name) || (item?.restaurant_name)}`,
                readCount: 0,
                // timestamp: data?.updated_at,
                timestamp: new Date().getTime(data?.updated_at),
                userTyping: false
            }
            connectionArr.push(model);
        })
        if (recentMessage?.length === 0) {
            await setUserList([...connectionArr])
        } else {
            var uniqueResultArrayObjOne = await connectionArr.filter(function (objOne) {
                return !recentMessage.some(function (objTwo) {
                    return objOne.id == objTwo.id;
                });
            });
            const finalUserList = await [...recentMessage, ...uniqueResultArrayObjOne];
            let uniqueUserList = finalUserList.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i);
            await setUserList(uniqueUserList)
            await setSearchUserList(uniqueUserList)
        }
    }
    // get recent message list....
    const fetchRecentMessage = (userId) => {
        const userNode = `user_${userId}`;
        let newRecentMessageArr = [];
        const recentMessageFire = firebase.database().ref("RecentMessage").child(userNode);
        recentMessageFire.on("value", async (snapshot) => {
            const response = await snapshot.val();
            for (let id in response) newRecentMessageArr.push({ id, ...response[id] });
            // const unique = [...new Map(newRecentMessageArr.map((item, key) => [item[key], item])).values()]
            setRecentMessage(newRecentMessageArr);
            // setRecentMessage(unique);
        });
    };
    // get chat message list ...
    const fetchMessage = async (item) => {
        setSelectedRecentMessage(item)
        setMessages([]);
        setConnectionId(item?.otherId)
        const senderId = profileData?.data?.user_data?.user_id;
        const receiverId = item?.otherId;
        if (senderId && receiverId) {
            const node = `${senderId}_${receiverId}`
            const messagesFirebase = await firebase.database().ref("Messages").child("PrivateMessages").child(node);
            messagesFirebase.on("value", async (snapshot) => {
                const response = snapshot.val();
                const messages = [];
                for (let id in response) messages.push({ id, ...response[id] });
                // let data = messages.filter(function (item) {
                //     return item.chat_id == node;
                // })
                messages?.length > 0 && setisChatStart(true)
                await setMessages(messages);
                setFirebaseNodeId(node)
            });
        }
        updateSenderRecentMessage(receiverId, false, async (res) => {
            const senderNode = `user_${userId}`;
            const reciverNode = `user_${res?.otherId}`;
            const result = await firebase.database().ref("RecentMessage").child(senderNode).child(reciverNode).set(res)

        })
        fetchRecentMessage(userId);
    };


    const handleChange = (e) => {
        const model = {}
        model[e.target.id] = e.target.value
        setMediaType('text')
        setSendText(model.comment)
    }

    const uploadImage = async (e) => {
        setSendTextWithImg(sendText)
        setSendText('')
        const model = {}
        model[e.target.id] = e.target.files[0]
        sendText !== '' ? setMediaType('textphotos') : setMediaType('photos')
        setSelectedFile(true)
        await dispatch(uploadMedia(model)).then(async (res) => {
            if (res?.success === 200) {
                await setMediaImage(res.media_url)
                setSelectedFile(true)
            }
        });
    }

    const removeChat = (data) => {
        firebase.database().ref("Messages").child("PrivateMessages").child(firebaseNodeId).child(data.id || data.uid).remove()
        setMsgDelete(false)
        // fetchMessage(data)
    }

    const handalSubmit = async (e, image) => {
        //console.log(mediaType,"mediaType");
        e.preventDefault();
        setIsEmoji(false)
        if (mediaImage !== '' || sendText?.trim() !== '' || sendTextWithImg?.trim() !== '') {

            const receiverId = selectedRecentMessage.otherId
            const receiverName = selectedRecentMessage.otherName
            const receiverImage = selectedRecentMessage.otherImage

            const senderId = userId
            const senderName = userName
            const senderImage = userImage

            const receiverChatNode = `${receiverId}_${senderId}`
            const senderChatNode = `${senderId}_${receiverId}`
                ;
            updateReciverRecentMessage(receiverId, true, async (res) => {
                const senderNode = `user_${userId}`;
                const reciverNode = `user_${receiverId}`;
                await firebase.database().ref("RecentMessage").child(reciverNode).child(senderNode).set(res)
                fetchRecentMessage(userId)
            })

            updateSenderRecentMessage(receiverId, true, async (res) => {
                const senderNode = `user_${userId}`;
                const reciverNode = `user_${res?.otherId}`;
                firebase.database().ref("RecentMessage").child(senderNode).child(reciverNode).set(res)
                fetchRecentMessage(userId)
            })

            const payload = {
                chat_id: senderChatNode,
                deleted: "",
                like: false,
                mediaImage: image != undefined ? image : mediaImage,
                mediaType: mediaType,
                message: sendText !== '' ? sendText : sendTextWithImg,
                receiverImage: receiverImage,
                receiverName: receiverName,
                receiverid: receiverId,
                senderImage: senderImage,
                sendername: senderName,
                senderid: senderId,
                timestamp: moment().unix()
            }
            const senderChat = firebase.database().ref("Messages").child("PrivateMessages").child(senderChatNode).push(payload).key;
            const receiverChat = firebase.database().ref("Messages").child("PrivateMessages").child(receiverChatNode).push(payload).key;


            fetchMessage(selectedRecentMessage)
            setSendText('')
            setSelectedFile(false)
            setMediaImage('')
            setSendTextWithImg('')

        }
    }


    // update recent message list...
    const updateSenderRecentMessage = async (reciverId, readCount, cb) => {
        const senderNode = `user_${userId}`;
        const reciverNode = `user_${reciverId}`;
        const recentMessageFire = firebase.database().ref("RecentMessage").child(senderNode);
        let response;
        recentMessageFire.on("value", async (snapshot) => {
            response = snapshot.val();
        });

        if (response?.hasOwnProperty(reciverNode)) {
            let res = response[reciverNode]
            res.readCount = readCount === true ? ++res.readCount : 0
            let lastMsg
            if (sendText !== '' || messages?.length === 0) {
                lastMsg = sendText
                res.timestamp = moment().unix()
            } else if (sendTextWithImg !== '') {
                lastMsg = sendTextWithImg
                res.timestamp = moment().unix()
            } else if (mediaType === "photos" && sendTextWithImg === '' && sendText === '') {
                lastMsg = "photo"
                res.timestamp = moment().unix()
            }
            else if (lastMsg === undefined) {
                lastMsg = res.lastmessage
            }
            res.lastmessage = lastMsg?.length > 0 ? lastMsg : res.lastmessage
            cb(res)
            return
        } else {
            if (selectedRecentMessage) {
                delete selectedRecentMessage?.id
                selectedRecentMessage.mediaType = mediaType
                selectedRecentMessage.lastmessage = sendText
                cb(selectedRecentMessage)
                return
            }
        }
    }

    // update reciver recent message list...
    const updateReciverRecentMessage = async (reciverId, readCount, cb) => {
        const reciverNode = `user_${reciverId}`;
        const senderNode = `user_${userId}`;
        const recentMessageFire = firebase.database().ref("RecentMessage").child(reciverNode)
        let response;
        recentMessageFire.on("value", async (snapshot) => {
            response = snapshot.val();
        });

        if (response?.hasOwnProperty(senderNode)) {
            let res = response[senderNode]

            let lastMsg
            if (sendText !== '' || messages?.length === 0) {
                lastMsg = sendText
                res.timestamp = moment().unix()
            } else if (sendTextWithImg !== '') {
                lastMsg = sendTextWithImg
                res.timestamp = moment().unix()
            } else if (mediaType === "photos" && sendTextWithImg === '' && sendText === '') {
                lastMsg = "photo"
                res.timestamp = moment().unix()
            }
            else if (lastMsg === undefined) {
                lastMsg = res.lastmessage
            }

            res.readCount = readCount === true ? ++res.readCount : 0
            res.lastmessage = lastMsg?.length > 0 ? lastMsg : res.lastmessage
            cb(res)
            return
        } else {
            const model = {
                lastmessage: sendText,
                mediaType: mediaType,
                otherId: userId,
                otherImage: userImage,
                otherName: userName,
                readCount: 1,
                timestamp: moment().unix(),
                userTyping: false
            }
            cb(model)
            return
        }
    }
    const handleSearch = (e) => {
        let searchVal = e.target.value
        let match = searchUserList.filter((el) => el?.otherName?.toLowerCase().indexOf(searchVal?.trim()?.toLowerCase()) !== -1)
        setUserList(match)
    }

    const onEmojiClick = async (event, emojiObject) => {
        let msg = sendText?.length > 0 ? `${sendText}${emojiObject?.emoji}` : emojiObject?.emoji
        await setSendText(msg);
        await setMediaType('text');
        //console.log("select Imoji");
        // await setIsEmoji(false);
    };

    const onKeyPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey) {
            e.preventDefault();
            let start = e.target.selectionStart,
                end = e.target.selectionEnd;
            setSendText(sendText.substring(0, start)
                + '\n' +
                sendText.substring(end), () => {
                    this.input.selectionStart = this.input.selectionEnd = start + 1
                })
        } else if (e.keyCode === 13) { // block enter
            e.preventDefault();
            handalSubmit(e)
        }

    };


    //  hanleprofilePop-Up
    useEffect(() => {
        const closeProfilePopUp = (event) => {
            if (deletePopUpRef.current && !deletePopUpRef.current.contains(event.target)) {
                setMsgDelete(false)
            }
        };
        document.body.addEventListener('click', closeProfilePopUp);
        return () => document.body.addEventListener('click', closeProfilePopUp);
    }, [msgDelete]);
    // End pop-up 
    let dateOptions = {
        hour: 'numeric',
        minute: 'numeric',
    };
    return (
        <div className='discover_page msgView'>
            {/* header */}
            {/* Desktop View Screen UI Start */}
            <div className='msgView desktop'>
                <div className='page_top_form flex justify-between'>
                    <h4 className='font-18 text-black'>{lang?.Message}</h4>
                </div>
                {/* layout */}
                <div className='msgBlock mt-3'>
                    <Tabs className="chatBox" selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
                        {/* left  block start  */}
                        <TabList className="tabList">
                            <Fragment>
                                {/* Search Messages block start */}
                                <div className='msgSearch'>
                                    <span className='searchIcon'><i className="fa fa-search" aria-hidden="true"></i></span>
                                    <input type="text" placeholder={lang?.search_messages} onChange={(e) => handleSearch(e)} />
                                </div>
                                {/* serch block end */}
                                {/* user list.. start */}
                                {userList?.length > 0 ? userList?.map((item, index) => {
                                    //console.log(item.timestamp,'timestamp')
                                    return (
                                        <Tab className="chatList" key={index}
                                            onClick={() => { tabIndex === index && fetchMessage(item); setisChatStart(true); setIsEmoji(false) }}
                                        >
                                            <div className="feed-user-info">
                                                <div className="user__pic"> {item?.otherImage ? <img src={item.otherImage} /> : <img src="https://alysei.s3.us-west-1.amazonaws.com/uploads/2022/01/99399461643374463.jpeg" />} </div>
                                                <div className="user__detail-data ml-4">
                                                    <span className="user__name"> <Link to="#">{item.otherName}</Link> </span>
                                                    <div className="flex">
                                                        {item?.lastmessage === "photo" && <span><i className="fa fa-picture-o" aria-hidden="true"></i> Photo</span>}
                                                        {item?.lastmessage !== "photo" && item?.lastmessage?.length < 30 && <span>{item?.lastmessage}</span>}
                                                        {item?.lastmessage !== "photo" && item?.lastmessage?.length >= 30 && <span>{item?.lastmessage.slice(0, 30)}...</span>}
                                                    </div>
                                                </div>
                                                <div className="about_profile ml-4">
                                                    {/* {item?.timestamp && <h4 className='font-14'>{moment(moment.unix(item?.timestamp)).format('LT')}</h4>} */}
                                                    {item?.readCount > 0 && <div className='msgNoti'> <span className='notiCount'>{item?.readCount}</span></div>}
                                                </div>
                                            </div>
                                        </Tab>
                                    )
                                }) :
                                    <div className='empty_data text-center'>
                                        <svg className='m-auto' width="76.26" height="67.363" viewBox="0 0 76.26 67.363">
                                            <path id="icons8_chat" d="M5.813,6A3.82,3.82,0,0,0,2,9.813V50.485A3.82,3.82,0,0,0,5.813,54.3h9.081c.079,1.36-.144,4.24-2.547,8.242a1.274,1.274,0,0,0,1.092,1.926,1.363,1.363,0,0,0,.278-.03c9.815-2.18,13.47-7.929,14.537-10.138h9.334v6.355A3.82,3.82,0,0,0,41.4,64.466h15.55a12.921,12.921,0,0,0,10.962,8.882,1.085,1.085,0,0,0,.179.015,1.275,1.275,0,0,0,1.182-1.743c-1.529-3.818-1.574-6.1-1.46-7.154h6.633a3.82,3.82,0,0,0,3.813-3.813V32.691a3.82,3.82,0,0,0-3.813-3.813H68.092V9.813A3.82,3.82,0,0,0,64.279,6Zm0,2.542H64.279A1.273,1.273,0,0,1,65.55,9.813V50.485a1.273,1.273,0,0,1-1.271,1.271H27.42a1.27,1.27,0,0,0-1.206.869c-.02.065-2.006,5.744-10.292,8.564,2.324-5.218,1.316-8.41,1.266-8.564a1.27,1.27,0,0,0-1.206-.869H5.813a1.273,1.273,0,0,1-1.271-1.271V9.813A1.273,1.273,0,0,1,5.813,8.542ZM15.981,23.794a1.271,1.271,0,1,0,0,2.542H38.859a1.271,1.271,0,0,0,0-2.542Zm27.962,0a1.271,1.271,0,0,0,0,2.542h5.084a1.271,1.271,0,1,0,0-2.542ZM15.981,31.42a1.271,1.271,0,1,0,0,2.542H43.943a1.271,1.271,0,1,0,0-2.542Zm52.111,0h6.355a1.273,1.273,0,0,1,1.271,1.271V60.653a1.273,1.273,0,0,1-1.271,1.271H66.821a1.279,1.279,0,0,0-1.137.7c-.139.278-1.162,2.592.437,7.725a10,10,0,0,1-6.946-7.363,1.269,1.269,0,0,0-1.251-1.062H41.4a1.273,1.273,0,0,1-1.271-1.271V54.3H64.279a3.82,3.82,0,0,0,3.813-3.813ZM9.626,44.13A1.27,1.27,0,0,0,8.355,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,9.626,44.13Zm6.355,0A1.27,1.27,0,0,0,14.71,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,15.981,44.13Zm6.355,0A1.27,1.27,0,0,0,21.065,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,22.336,44.13Zm6.355,0A1.27,1.27,0,0,0,27.42,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,28.691,44.13Zm6.355,0A1.27,1.27,0,0,0,33.775,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,35.046,44.13Zm6.355,0A1.27,1.27,0,0,0,40.13,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,41.4,44.13Zm6.355,0A1.27,1.27,0,0,0,46.485,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,47.756,44.13Zm6.355,0A1.27,1.27,0,0,0,52.84,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,54.111,44.13Zm6.355,0A1.27,1.27,0,0,0,59.2,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,60.466,44.13Z" transform="translate(-2 -6)" />
                                        </svg>
                                        <h4 className="font-18 text-black">{lang?.NO_message}</h4>
                                    </div>
                                }
                                {/* user list end. */}
                            </Fragment>
                        </TabList>
                        {/* left block end */}

                        {/* right  block start */}
                        <div className='chatTabContent'>
                            {/*chat messages...  */}
                            {userList?.length > 0 && userList?.map((data, index) => {
                                return (
                                    <Fragment>
                                        <TabPanel className="chatMain" key={index}>
                                            {/* chat header */}
                                            <div className='chatHeader'>
                                                <div className="feed-user-info">
                                                    <div className="user__pic">{data.otherImage ? <img src={data.otherImage} /> : <img src="https://alysei.s3.us-west-1.amazonaws.com/uploads/2022/01/99399461643374463.jpeg" />} </div>
                                                    <div className="user__detail-data ml-4">
                                                        <span className="user__name">  <Link to="#">{data.otherName}</Link></span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* chat body */}
                                            <div className='msgBody mt-1'>
                                                {messages?.length > 0 && messages.map((item, index) => {
                                                    //console.log(item,"item");
                                                    let messageArr = item?.message?.split("\n")
                                                    return (
                                                        <div key={index} className={parseInt(item.chat_id) === parseInt(firebaseNodeId) ? "recivermsgdetail" : "sendermsgdetail"} >
                                                            {
                                                                // parseInt(item.chat_id) === parseInt(firebaseNodeId) && 
                                                                <div ref={deletePopUpRef}
                                                                    className={item?.mediaType === "textphotos" || item?.mediaType === "photos" ? "msgDelete forImg" : "msgDelete"}
                                                                    onClick={() => { setMsgDelete(!msgDelete); setChatId(item.uid || item.id) }}>
                                                                     {item.senderid === userId ? <i className="fa fa-ellipsis-v" aria-hidden="true"></i> : '' }
                                                                    
                                                                </div>
                                                            }
                                                            {msgDelete && (item.uid || item.id) === chatId &&
                                                                <div className="postView">
                                                                    <ul>
                                                                        {/* <li> Forword</li> */}
                                                                        <li onClick={() => removeChat(item)}>
                                                                            <div className='close'>
                                                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                                                            </div>
                                                                            {lang?.only_delete}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            }
                                                            {item?.message?.length > 0 && item?.mediaType !== "textphotos" &&
                                                                <div className={parseInt(item.chat_id) === parseInt(firebaseNodeId) ? " reciver" : 'sender'}>
                                                                    {messageArr?.map((msg) => <p> {msg}</p>)}
                                                                    <p className='sendTime'>{moment(moment.unix(item.timestamp)).format('LT')}</p>
                                                                </div>
                                                            }
                                                            {item?.mediaImage?.length > 0 &&
                                                                <div className={parseInt(item.chat_id) === parseInt(firebaseNodeId) ? " reciver imgBlock" : 'sender imgBlock'}>
                                                                    <div className='msg imgBlock' onClick={() => { setIsOpenImage(true); setImageData(item?.mediaImage) }}><img src={`${item?.mediaImage}`} alt='image' /></div>
                                                                    {item?.mediaType === "textphotos" && messageArr?.map((msg) => <p> {msg}</p>)}
                                                                    <p className='sendTime'>{moment(moment.unix(item.timestamp)).format('LT')}</p>
                                                                </div>
                                                            }
                                                            <div ref={messagesEndRef} />
                                                        </div>
                                                    )
                                                })
                                                }
                                            </div>
                                        </TabPanel>
                                    </Fragment>
                                )
                            })
                            }

                            {/* write comment */}
                            {userList?.length > 0 && isChatStart &&
                                <form className="cmnt-form replay_cmnt replayBlock flex justify-between items-center"
                                    onSubmit={(e) => handalSubmit(e)}
                                >
                                    <textarea
                                        height={100}
                                        className="cmnt-write pl-8 relative relative relative"
                                        name='message'
                                        id='comment'
                                        placeholder={lang?.write_message}
                                        value={sendText}
                                        onChange={(e) => handleChange(e)}
                                        onKeyDown={onKeyPress}
                                    />
                                    {/* <textarea id="message"></textarea> */}
                                    <div className="post-icons-option iconLeft">
                                        <Link to="#"
                                            onClick={() => setIsEmoji(!isEmoji)}>
                                            <i className="far fa-smile" aria-hidden="true"></i>
                                        </Link>
                                    </div>

                                    <div>{isEmoji && <Picker onEmojiClick={onEmojiClick} />} </div>
                                    <div className="post-icons-option rightIcon flex">
                                        {/* <div className='fileAttach mr-4'> <label className='hide-input'> <span><i className="fa fa-paperclip" aria-hidden="true"></i></span> <input type="file" name='file' id='media' onChange={(e) => uploadImage(e)} /> </label> </div> */}
                                        <div className='fileAttach'> <label className='hide-input'> <span><i className="fa fa-camera" aria-hidden="true"></i></span><input type="file" name='file' id='media' onChange={(e) => uploadImage(e)} /> </label></div>
                                    </div>
                                    <div className="post-icons-option sendBtn" onClick={(e) => handalSubmit(e)}> <Link to="#" className='btn'>  <i className="fa fa-arrow-right" aria-hidden="true"></i></Link> </div>
                                </form>

                            }

                            {/* no new chat */}
                            {messages?.length === 0 &&
                                <div className='empty_data text-center'>
                                    <svg className='m-auto' width="76.26" height="67.363" viewBox="0 0 76.26 67.363">
                                        <path id="icons8_chat" d="M5.813,6A3.82,3.82,0,0,0,2,9.813V50.485A3.82,3.82,0,0,0,5.813,54.3h9.081c.079,1.36-.144,4.24-2.547,8.242a1.274,1.274,0,0,0,1.092,1.926,1.363,1.363,0,0,0,.278-.03c9.815-2.18,13.47-7.929,14.537-10.138h9.334v6.355A3.82,3.82,0,0,0,41.4,64.466h15.55a12.921,12.921,0,0,0,10.962,8.882,1.085,1.085,0,0,0,.179.015,1.275,1.275,0,0,0,1.182-1.743c-1.529-3.818-1.574-6.1-1.46-7.154h6.633a3.82,3.82,0,0,0,3.813-3.813V32.691a3.82,3.82,0,0,0-3.813-3.813H68.092V9.813A3.82,3.82,0,0,0,64.279,6Zm0,2.542H64.279A1.273,1.273,0,0,1,65.55,9.813V50.485a1.273,1.273,0,0,1-1.271,1.271H27.42a1.27,1.27,0,0,0-1.206.869c-.02.065-2.006,5.744-10.292,8.564,2.324-5.218,1.316-8.41,1.266-8.564a1.27,1.27,0,0,0-1.206-.869H5.813a1.273,1.273,0,0,1-1.271-1.271V9.813A1.273,1.273,0,0,1,5.813,8.542ZM15.981,23.794a1.271,1.271,0,1,0,0,2.542H38.859a1.271,1.271,0,0,0,0-2.542Zm27.962,0a1.271,1.271,0,0,0,0,2.542h5.084a1.271,1.271,0,1,0,0-2.542ZM15.981,31.42a1.271,1.271,0,1,0,0,2.542H43.943a1.271,1.271,0,1,0,0-2.542Zm52.111,0h6.355a1.273,1.273,0,0,1,1.271,1.271V60.653a1.273,1.273,0,0,1-1.271,1.271H66.821a1.279,1.279,0,0,0-1.137.7c-.139.278-1.162,2.592.437,7.725a10,10,0,0,1-6.946-7.363,1.269,1.269,0,0,0-1.251-1.062H41.4a1.273,1.273,0,0,1-1.271-1.271V54.3H64.279a3.82,3.82,0,0,0,3.813-3.813ZM9.626,44.13A1.27,1.27,0,0,0,8.355,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,9.626,44.13Zm6.355,0A1.27,1.27,0,0,0,14.71,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,15.981,44.13Zm6.355,0A1.27,1.27,0,0,0,21.065,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,22.336,44.13Zm6.355,0A1.27,1.27,0,0,0,27.42,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,28.691,44.13Zm6.355,0A1.27,1.27,0,0,0,33.775,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,35.046,44.13Zm6.355,0A1.27,1.27,0,0,0,40.13,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,41.4,44.13Zm6.355,0A1.27,1.27,0,0,0,46.485,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,47.756,44.13Zm6.355,0A1.27,1.27,0,0,0,52.84,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,54.111,44.13Zm6.355,0A1.27,1.27,0,0,0,59.2,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,60.466,44.13Z" transform="translate(-2 -6)" />
                                    </svg>
                                    <h4 className="font-18 text-black">{lang?.No_new_chat}</h4>
                                </div>
                            }
                        </div>

                        {/* right block end */}
                    </Tabs>
                </div >
            </div>
            {/* Desktop View Screen UI En */}

            {/* Mobile View Screen UI Start */}
            <div className='msgView Mobile'>
                <div className='page_top_form flex justify-between'>
                    <h4 className='font-18 text-black'>{lang?.Message}</h4>
                </div>
                {/* layout */}
                <div className='msgBlock mt-3'>
                    <Tabs className="chatBox" selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
                        {mobileViewList ?
                            <Fragment>

                                {/* left  block start  */}
                                <TabList className="tabList" onClick={() => setMobileViewList(false)}>
                                    <Fragment>
                                        {/* Search Messages block start */}
                                        <div className='msgSearch'>
                                            <span className='searchIcon'><i className="fa fa-search" aria-hidden="true"></i></span>
                                            <input type="text" placeholder="Search Messages" onChange={(e) => handleSearch(e)} />
                                        </div>
                                        {/* serch block end */}
                                        {/* user list.. start */}
                                        {userList?.length > 0 ? userList?.map((item, index) => {
                                            return (
                                                <Tab className="chatList" key={index}
                                                    onClick={() => { tabIndex === index && fetchMessage(item); setIsEmoji(false) }}
                                                >
                                                    <div className="feed-user-info">
                                                        <div className="user__pic"> {item.otherImage ? <img src={item.otherImage} /> : <img src="https://alysei.s3.us-west-1.amazonaws.com/uploads/2022/01/99399461643374463.jpeg" />} </div>
                                                        <div className="user__detail-data ml-4">
                                                            <span className="user__name"> <Link to="#">{item.otherName}</Link> </span>
                                                            <div className="flex">
                                                                {item?.lastmessage === "photo" && <span><i className="fa fa-picture-o" aria-hidden="true"></i> Photo</span>}
                                                                {item?.lastmessage !== "photo" && item?.lastmessage?.length < 30 && <span>{item?.lastmessage}</span>}
                                                                {item?.lastmessage !== "photo" && item?.lastmessage?.length >= 30 && <span>{item?.lastmessage.slice(0, 30)}...</span>}
                                                            </div>
                                                        </div>
                                                        <div className="about_profile ml-4">
                                                            {/* <h4 className='font-16'>{moment(moment.unix(item.timestamp).format("M/D/Y H:m:s")).fromNow()}</h4> */}
                                                            {item?.timestamp && <h4 className='font-14'>{moment(moment.unix(item?.timestamp)).format('LT')}</h4>}
                                                            {item.readCount > 0 && <div className='msgNoti'> <span className='notiCount'>{item.readCount}</span></div>}
                                                        </div>
                                                    </div>
                                                </Tab>
                                            )
                                        }) :
                                            <div className='empty_data text-center'>
                                                <svg className='m-auto' width="76.26" height="67.363" viewBox="0 0 76.26 67.363">
                                                    <path id="icons8_chat" d="M5.813,6A3.82,3.82,0,0,0,2,9.813V50.485A3.82,3.82,0,0,0,5.813,54.3h9.081c.079,1.36-.144,4.24-2.547,8.242a1.274,1.274,0,0,0,1.092,1.926,1.363,1.363,0,0,0,.278-.03c9.815-2.18,13.47-7.929,14.537-10.138h9.334v6.355A3.82,3.82,0,0,0,41.4,64.466h15.55a12.921,12.921,0,0,0,10.962,8.882,1.085,1.085,0,0,0,.179.015,1.275,1.275,0,0,0,1.182-1.743c-1.529-3.818-1.574-6.1-1.46-7.154h6.633a3.82,3.82,0,0,0,3.813-3.813V32.691a3.82,3.82,0,0,0-3.813-3.813H68.092V9.813A3.82,3.82,0,0,0,64.279,6Zm0,2.542H64.279A1.273,1.273,0,0,1,65.55,9.813V50.485a1.273,1.273,0,0,1-1.271,1.271H27.42a1.27,1.27,0,0,0-1.206.869c-.02.065-2.006,5.744-10.292,8.564,2.324-5.218,1.316-8.41,1.266-8.564a1.27,1.27,0,0,0-1.206-.869H5.813a1.273,1.273,0,0,1-1.271-1.271V9.813A1.273,1.273,0,0,1,5.813,8.542ZM15.981,23.794a1.271,1.271,0,1,0,0,2.542H38.859a1.271,1.271,0,0,0,0-2.542Zm27.962,0a1.271,1.271,0,0,0,0,2.542h5.084a1.271,1.271,0,1,0,0-2.542ZM15.981,31.42a1.271,1.271,0,1,0,0,2.542H43.943a1.271,1.271,0,1,0,0-2.542Zm52.111,0h6.355a1.273,1.273,0,0,1,1.271,1.271V60.653a1.273,1.273,0,0,1-1.271,1.271H66.821a1.279,1.279,0,0,0-1.137.7c-.139.278-1.162,2.592.437,7.725a10,10,0,0,1-6.946-7.363,1.269,1.269,0,0,0-1.251-1.062H41.4a1.273,1.273,0,0,1-1.271-1.271V54.3H64.279a3.82,3.82,0,0,0,3.813-3.813ZM9.626,44.13A1.27,1.27,0,0,0,8.355,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,9.626,44.13Zm6.355,0A1.27,1.27,0,0,0,14.71,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,15.981,44.13Zm6.355,0A1.27,1.27,0,0,0,21.065,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,22.336,44.13Zm6.355,0A1.27,1.27,0,0,0,27.42,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,28.691,44.13Zm6.355,0A1.27,1.27,0,0,0,33.775,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,35.046,44.13Zm6.355,0A1.27,1.27,0,0,0,40.13,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,41.4,44.13Zm6.355,0A1.27,1.27,0,0,0,46.485,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,47.756,44.13Zm6.355,0A1.27,1.27,0,0,0,52.84,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,54.111,44.13Zm6.355,0A1.27,1.27,0,0,0,59.2,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,60.466,44.13Z" transform="translate(-2 -6)" />
                                                </svg>
                                                <h4 className="font-18 text-black">{lang?.NO_message}</h4>
                                            </div>
                                        }
                                        {/* user list end. */}
                                    </Fragment>
                                </TabList>
                                {/* left block end */}
                            </Fragment>
                            : <Fragment>
                                {/* right  block start */}
                                <div className='chatTabContent'>
                                    {/*chat messages...  */}
                                    {userList?.length > 0 && userList?.map((data, index) => {
                                        return (
                                            <Fragment>
                                                <TabPanel className="chatMain" key={index}>
                                                    {/* chat header */}
                                                    <div className='chatHeader'>
                                                        <div className="feed-user-info">
                                                            <div className='backBtn'>
                                                                <Link to="#" onClick={() => setMobileViewList(true)}>
                                                                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                                                </Link>
                                                            </div>
                                                            <div className="user__pic">{data.otherImage ? <img src={data.otherImage} /> : <img src="https://alysei.s3.us-west-1.amazonaws.com/uploads/2022/01/99399461643374463.jpeg" />} </div>
                                                            <div className="user__detail-data ml-4">
                                                                <span className="user__name">  <Link to="#">{data.otherName}</Link></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* chat body */}
                                                    <div className='msgBody mt-1'>
                                                        {messages?.length > 0 && messages.map((item, index) => {
                                                            let messageArr = item?.message?.split("\n")
                                                            return (
                                                                <div key={index} className={parseInt(item.chat_id) === parseInt(firebaseNodeId) ? "recivermsgdetail" : "sendermsgdetail"} >
                                                                    {
                                                                        // parseInt(item.chat_id) === parseInt(firebaseNodeId) && 
                                                                        <div ref={deletePopUpRef}
                                                                            className={item?.mediaType !== "textphotos" ? 'msgDelete' : "msgDelete forImg"}
                                                                            onClick={() => { setMsgDelete(!msgDelete); setChatId(item.uid || item.id) }}>
                                                                            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                                        </div>
                                                                    }
                                                                    {msgDelete && (item.uid || item.id) === chatId &&
                                                                        <div className="postView">
                                                                            <ul>
                                                                                {/* <li> Forword</li> */}
                                                                                <li onClick={() => removeChat(item)}>
                                                                                    <div className='close'>
                                                                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                                                                    </div>
                                                                                    {lang?.only_delete}
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    }
                                                                    {item?.message?.length > 0 && item?.mediaType !== "textphotos" &&
                                                                        <div className={parseInt(item.chat_id) === parseInt(firebaseNodeId) ? " reciver" : 'sender'}>
                                                                            {messageArr?.map((msg) => <p> {msg}</p>)}
                                                                            <p className='sendTime'>{moment(moment.unix(item.timestamp)).format('LT')}</p>
                                                                        </div>
                                                                    }
                                                                    {item?.mediaImage?.length > 0 &&
                                                                        <div className={parseInt(item.chat_id) === parseInt(firebaseNodeId) ? " reciver" : 'sender'} >
                                                                            {/* <img src={`${item.mediaImage}`} alt='image' /> */}
                                                                            <div className='msg imgBlock' onClick={() => { setIsOpenImage(true); setImageData(item?.mediaImage) }}><img src={`${item?.mediaImage}`} alt='image' /></div>
                                                                            {item?.mediaType === "textphotos" && messageArr?.map((msg) => <p> {msg}</p>)}
                                                                            <p className='sendTime'>{moment(moment.unix(item.timestamp)).format('LT')}</p>
                                                                        </div>
                                                                    }
                                                                    <div ref={messagesEndRef} />
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                    </div>
                                                </TabPanel>
                                            </Fragment>
                                        )
                                    })
                                    }

                                    {/* write comment */}
                                    {userList?.length > 0 && isChatStart &&
                                        <form className="cmnt-form replay_cmnt replayBlock flex justify-between items-center" onSubmit={(e) => handalSubmit(e)}>
                                            <textarea
                                                height={100}
                                                className="cmnt-write pl-8 relative relative relative" name='message' id='comment'
                                                placeholder={lang?.write_message} value={sendText} onChange={(e) => handleChange(e)} />
                                            <div className="post-icons-option iconLeft">
                                                <Link to="#"> <i className="far fa-smile" aria-hidden="true"></i> </Link> </div>
                                            <div className="post-icons-option rightIcon flex">
                                                {/* <div className='fileAttach mr-4'> <label className='hide-input'> <span><i className="fa fa-paperclip" aria-hidden="true"></i></span> <input type="file" name='file' id='media' onChange={(e) => uploadImage(e)} /> </label> </div> */}
                                                <div className='fileAttach'> <label className='hide-input'> <span><i className="fa fa-camera" aria-hidden="true"></i></span><input type="file" name='file' id='media' onChange={(e) => uploadImage(e)} /> </label></div>
                                            </div>
                                            <div className="post-icons-option sendBtn" onClick={(e) => handalSubmit(e)}> <Link to="#" className='btn'>  <i className="fa fa-arrow-right" aria-hidden="true"></i></Link> </div>
                                        </form>
                                    }

                                    {/* no new chat */}
                                    {messages?.length === 0 &&
                                        <div className='empty_data text-center'>
                                            <svg className='m-auto' width="76.26" height="67.363" viewBox="0 0 76.26 67.363">
                                                <path id="icons8_chat" d="M5.813,6A3.82,3.82,0,0,0,2,9.813V50.485A3.82,3.82,0,0,0,5.813,54.3h9.081c.079,1.36-.144,4.24-2.547,8.242a1.274,1.274,0,0,0,1.092,1.926,1.363,1.363,0,0,0,.278-.03c9.815-2.18,13.47-7.929,14.537-10.138h9.334v6.355A3.82,3.82,0,0,0,41.4,64.466h15.55a12.921,12.921,0,0,0,10.962,8.882,1.085,1.085,0,0,0,.179.015,1.275,1.275,0,0,0,1.182-1.743c-1.529-3.818-1.574-6.1-1.46-7.154h6.633a3.82,3.82,0,0,0,3.813-3.813V32.691a3.82,3.82,0,0,0-3.813-3.813H68.092V9.813A3.82,3.82,0,0,0,64.279,6Zm0,2.542H64.279A1.273,1.273,0,0,1,65.55,9.813V50.485a1.273,1.273,0,0,1-1.271,1.271H27.42a1.27,1.27,0,0,0-1.206.869c-.02.065-2.006,5.744-10.292,8.564,2.324-5.218,1.316-8.41,1.266-8.564a1.27,1.27,0,0,0-1.206-.869H5.813a1.273,1.273,0,0,1-1.271-1.271V9.813A1.273,1.273,0,0,1,5.813,8.542ZM15.981,23.794a1.271,1.271,0,1,0,0,2.542H38.859a1.271,1.271,0,0,0,0-2.542Zm27.962,0a1.271,1.271,0,0,0,0,2.542h5.084a1.271,1.271,0,1,0,0-2.542ZM15.981,31.42a1.271,1.271,0,1,0,0,2.542H43.943a1.271,1.271,0,1,0,0-2.542Zm52.111,0h6.355a1.273,1.273,0,0,1,1.271,1.271V60.653a1.273,1.273,0,0,1-1.271,1.271H66.821a1.279,1.279,0,0,0-1.137.7c-.139.278-1.162,2.592.437,7.725a10,10,0,0,1-6.946-7.363,1.269,1.269,0,0,0-1.251-1.062H41.4a1.273,1.273,0,0,1-1.271-1.271V54.3H64.279a3.82,3.82,0,0,0,3.813-3.813ZM9.626,44.13A1.27,1.27,0,0,0,8.355,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,9.626,44.13Zm6.355,0A1.27,1.27,0,0,0,14.71,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,15.981,44.13Zm6.355,0A1.27,1.27,0,0,0,21.065,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,22.336,44.13Zm6.355,0A1.27,1.27,0,0,0,27.42,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,28.691,44.13Zm6.355,0A1.27,1.27,0,0,0,33.775,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,35.046,44.13Zm6.355,0A1.27,1.27,0,0,0,40.13,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,41.4,44.13Zm6.355,0A1.27,1.27,0,0,0,46.485,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,47.756,44.13Zm6.355,0A1.27,1.27,0,0,0,52.84,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,54.111,44.13Zm6.355,0A1.27,1.27,0,0,0,59.2,45.4v2.542a1.271,1.271,0,1,0,2.542,0V45.4A1.27,1.27,0,0,0,60.466,44.13Z" transform="translate(-2 -6)" />
                                            </svg>
                                            <h4 className="font-18 text-black">{lang?.No_new_chat}</h4>
                                        </div>
                                    }
                                </div>
                                {/* right block end */}
                            </Fragment>
                        }

                    </Tabs>
                </div >
            </div>
            {/* Mobile View Screen UI End */}

            {/* image gallery */}
            {isOpenImage &&
                <div className='image--light--pop'>
                    <ReactImageVideoLightbox
                        data={[{ url: imageData, type: "photo", altTag: "image", }]}
                        startIndex={0}
                        // showResourceCount={true}
                        onCloseCallback={() => { setIsOpenImage(false); setImageData('') }}
                    // onNavigationCallback={(currentIndex) =>
                    //     console.log(`Current index: ${currentIndex}`)
                    // }
                    />
                </div>
            }

            {/* upload image modal */}
            <Modal
                isOpen={selectedFile}
                ariaHideApp={false}
                style={{
                    overlay: {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.75)",
                    },
                    content: {
                        position: "absolute",
                        top: "0",
                        left: "0%",
                        right: "0%",
                        bottom: "200px",
                        border: "1px solid #ccc",
                        background: "#fff",
                        overflow: "auto",
                        WebkitOverflowScrolling: "touch",
                        borderRadius: "4px",
                        padding: "0",
                        // outline: 'none',
                    },
                }}
            >
                <div className="popup_header flex justify-between items-center">
                    <h4 className="page__title">{lang?.Image_with_text}</h4>
                    <button className="close_btn--modal" onClick={() => setSelectedFile(false)} > {lang?.close} </button>
                </div>
                <div className="card card--block modal_box msgViewPopup">
                    <form onSubmit={(e) => handalSubmit(e, mediaImage)}>
                        <img src={mediaImage} alt="img" />
                        <div >
                            <input
                                type="text"
                                placeholder={lang?.Enter_your_text}
                                value={sendTextWithImg}
                                onChange={(e) => { setSendTextWithImg(e.target.value); setMediaType("textphotos") }}
                            />
                        </div>
                    </form>
                    <div className="view__hub__btn"> <button type="button" className="btn btnTeal" onClick={(e) => handalSubmit(e, mediaImage)} >{lang?.upload}</button>
                    </div>
                </div>
                <div>
                </div>
            </Modal>
        </div >
    );

}
